import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Modal,
  Alert,
} from '@mui/material';
import { set } from 'date-fns';
import { useLoginStore } from '../../stores/AuthStatusStore';
import LoginDefault from '../../components/Login/newLogin/';

interface Dependente {
  nomeDependente: string;
  grauParentescoNome: string;
  codigoGrauParentesco: number;
  codigoSituacao: number;
}

interface Contato {
  tipo: string;
  descricaoContato: string;
}

interface Associado {
  nome: string;
  cpf: string;
  dataDeNascimento: string;
  dependentes: Dependente[];
  contatos: Contato[];
  codigo: number;
  nomeFantasiaDaEmpresa: string;
}

/* interface ApiResponse {
  dados: Associado[];
} */

const GDFSearch: React.FC = () => {
  const [cpf, setCpf] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const logado = useLoginStore(x => x.login);
  const [loading, setLoading] = useState<boolean>(false);
  const [celular, setCelular] = useState<string>('');
  const [associado, setAssociado] = useState<any>(null);
  const [dependentes, setDependentes] = useState<any>(null);
  const [error, setError] = useState<string>('');
  const [showLinkModal, setShowLinkModal] = useState<boolean>(false);
  const [apiLink, setApiLink] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [loadingLink, setLoadingLink] = useState<boolean>(false);

  const handleCpfChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setCpf(event.target.value);
    setError('');
  };
  const handleEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setEmail(event.target.value);
    setError('');
  };
  const handleCelularChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setCelular(event.target.value);
    setError('');
  };

  const handleFormSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault();

    const cleanedCpf = cpf.replace(/[^\d]+/g, '');

    if (cleanedCpf.length !== 11) {
      setError('CPF deve conter 11 dígitos');
      return;
    }

    setLoading(true);
    setAssociado(null);
    setSuccessMessage('');

    try {
      const urlBase = process.env.REACT_APP_URL_BASE;
      const token = process.env.REACT_APP_TOKEN_S4E_V2;
      const url = `${urlBase}/v2/api/Associados?token=${token}&cpfAssociado=${cleanedCpf}`;

      const response = await axios.get(url);

      if (response.data.dados.length > 0) {
        const associadoData = response.data.dados.filter(
          x => x.codigoDaEmpresa === 27855,
        );
        if (!associadoData) {
          setError('Este CPF não pertence à EMPRESARIAL GDFC');
          return;
        }

        const associadoAtivo = associadoData.find(
          (x: Associado) =>
            Array.isArray(x.dependentes) &&
            x.dependentes.some(
              (dep: Dependente) =>
                dep.codigoGrauParentesco === 1 &&
                (dep.codigoSituacao === 1 ||
                  dep.codigoSituacao === 16 ||
                  dep.codigoSituacao === 111 ||
                  dep.codigoSituacao === 116 ||
                  dep.codigoSituacao === 118 ||
                  dep.codigoSituacao === 119),
            ),
        );

        if (associadoAtivo) {
          setAssociado(associadoAtivo);
          setDependentes(
            associadoAtivo.dependentes.filter(
              x => x.codigoGrauParentesco !== 1,
            ),
          );
          setError('');
          const emailAssociado = associadoAtivo.contatos.find(
            c => c.tipo === 'E-mail',
          );
          setEmail(emailAssociado ? emailAssociado.descricaoContato : '');
        } else {
          const urlBase = process.env.REACT_APP_OG_API_URL;
          const associadoVO = await axios.get(
            `${urlBase}/info/AssociadoCpf?cpf=${cleanedCpf}`,
          );
          if (
            associadoVO.data.cd_cod_contrato_s4_e === 27855 &&
            associadoVO.data.cd_status != 3
          ) {
            setAssociado(associadoVO.data);
            setDependentes(associadoVO.data.Dependente || []);
            setEmail(associadoVO.data.ds_email || '');
            setError('');
          } else {
            setError('Nenhum associado encontrado com este CPF');
            return;
          }
        }
      } else {
        const urlBase = process.env.REACT_APP_OG_API_URL;
        const associadoVO = await axios.get(
          `${urlBase}/info/AssociadoCpf?cpf=${cleanedCpf}`,
        );
        if (
          associadoVO.data.cd_cod_contrato_s4_e === 27855 &&
          associadoVO.data.cd_status != 3
        ) {
          setAssociado(associadoVO.data);
          setDependentes(associadoVO.data.Dependente || []);
          setEmail(associadoVO.data.ds_email || '');
          setError('');
        } else {
          setError('Nenhum associado encontrado com este CPF');
          return;
        }
      }
      setSuccessMessage('Associado válido e ativo encontrado!');
    } catch (err) {
      setError('Erro ao buscar associado. Tente novamente mais tarde.');
      console.error('Erro na busca:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateLink = async () => {
    if (!associado) return;

    setLoadingLink(true);
    setError('');

    try {
      const UrlApiV2 = process.env.REACT_APP_OG_API_URL;
      const id = associado.codigo || associado.id_associado;

      const response = await axios.get(
        `${UrlApiV2}/generate/AssinaturaGdf?id_associado=${id}&email=${encodeURIComponent(
          email,
        )}`,
      );

      if (response.data && response.data.linkGerado) {
        setApiLink(response.data.linkGerado);
        setCelular(
          associado.contatos
            ? formatPhoneNumber(associado.contatos)
            : associado.nu_ddd_cel + associado.nu_celular,
        );
        setShowLinkModal(true);
      } else {
        throw new Error('Resposta da API não contém um link válido');
      }
    } catch (error) {
      console.error('Erro ao gerar link:', error);
      setError('Erro ao gerar link de assinatura. Tente novamente.');
    } finally {
      setLoadingLink(false);
    }
  };

  const formatPhoneNumber = (contatos: Contato[]): string => {
    const phone = contatos.find(c => c.tipo === 'Celular');
    return phone?.descricaoContato || 'Não informado';
  };

  return (
    <Container>
      {!logado ? (
        <div className="mx-auto mt-20 p-10 py-20 border rounded shadow">
          <h2 className="text-[2rem] font-semibold text-primary-main mt-12 text-center">
            Envio de proposta venda do GDF para assinatura
          </h2>
          <LoginDefault corretor />
        </div>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="120vh"
          margin="8rem"
        >
          <Paper
            elevation={3}
            style={{ padding: '2rem', maxWidth: '600px', width: '100%' }}
          >
            <Typography variant="h5" component="h3" gutterBottom>
              Gerar Proposta
            </Typography>
            <Typography variant="body1" gutterBottom>
              Informe o CPF do servidor GDF
            </Typography>

            {successMessage && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {successMessage}
              </Alert>
            )}

            <form onSubmit={handleFormSubmit}>
              <TextField
                fullWidth
                margin="normal"
                label="Número do CPF"
                variant="outlined"
                value={cpf}
                onChange={handleCpfChange}
                error={!!error}
                helperText={error}
                required
              />
              {!associado && (
                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Buscar'}
                  </Button>
                </Box>
              )}
            </form>

            {associado && (
              <Box mt={4}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6" gutterBottom>
                    Dados do Associado
                  </Typography>
                  <Chip
                    label={`Código: ${
                      associado.codigo || associado.id_associado
                    }`}
                    color="primary"
                    variant="outlined"
                  />
                </Box>
                <List>
                  <ListItem>
                    <ListItemText
                      primary="Nome"
                      secondary={associado.nome || associado.nm_associado}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="CPF"
                      secondary={associado.cpf || associado.nu_cpf}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Data de Nascimento"
                      secondary={new Date(
                        associado.dataDeNascimento || associado.dt_nasc,
                      ).toLocaleDateString()}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Telefone"
                      secondary={
                        associado.contatos
                          ? formatPhoneNumber(associado.contatos)
                          : associado.nu_ddd_cel + associado.nu_celular
                      }
                    />
                  </ListItem>
                  <Divider />
                  {dependentes.length > 0 && (
                    <>
                      <ListItem>
                        <ListItemText
                          primary="Dependentes"
                          secondary={dependentes
                            .map(d => d.nomeDependente || d.nm_dependente)
                            .join(', ')}
                        />
                      </ListItem>
                      <Divider />
                    </>
                  )}
                </List>
                <Typography
                  variant="h5"
                  gutterBottom
                  color="error"
                  sx={{
                    fontSize: '1.2rem',
                    marginTop: '15px',
                    marginBottom: '15px',
                    backgroundColor: '#e0e0e0',
                    padding: '12px',
                    borderRadius: '4px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  }}
                >
                  O documento para assinatura será enviado ao e-mail abaixo.
                  Favor validar o email antes de enviar ou , se necessário ,
                  altere o email de envio !
                </Typography>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Email do associado"
                  variant="outlined"
                  value={email}
                  onChange={handleEmailChange}
                  required
                />

                <Box mt={3} display="flex" justifyContent="space-between">
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setAssociado(null)}
                  >
                    Nova Consulta
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGenerateLink}
                    disabled={loadingLink}
                  >
                    {loadingLink ? <CircularProgress size={24} /> : 'Enviar'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="warning"
                    onClick={() => (window.location.href = '/')}
                  >
                    Sair
                  </Button>
                </Box>
              </Box>
            )}
          </Paper>
        </Box>
      )}

      <Modal
        open={showLinkModal}
        onClose={() => setShowLinkModal(false)}
        aria-labelledby="link-modal-title"
        aria-describedby="link-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
          }}
        >
          <Typography id="link-modal-title" variant="h6" component="h2">
            Link Gerado
          </Typography>
          <Typography id="link-modal-description" sx={{ mt: 2 }}>
            Link para assinatura da proposta:
          </Typography>
          <TextField
            fullWidth
            value={apiLink}
            margin="normal"
            InputProps={{
              readOnly: true,
            }}
          />

          {associado && (
            <>
              <Typography sx={{ mt: 3 }}>
                O link de assinatura será enviado para o WhatsApp no numero de
                celular abaixo. Caso necessário altere o numero!
              </Typography>
              <TextField
                fullWidth
                value={celular}
                margin="normal"
                label="Número de telefone"
                onChange={handleCelularChange}
              />
              <Box
                sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    try {
                      const urlBase = process.env.REACT_APP_OG_API_URL;
                      const response = await axios.post(
                        `${urlBase}/register/SendWhatsApp`,
                        {
                          number: Number(celular),
                          name: associado.nome || associado.nm_associado,
                          id: apiLink.replace('https://assina.ae/', ''),
                          vendedor: 65083,
                        },
                      );

                      // Exemplo de tratamento de resposta
                      if (response.status === 200) {
                        alert('Mensagem enviada com sucesso!');
                        setAssociado(null);
                        setShowLinkModal(false);
                      } else {
                        alert(
                          'Erro ao enviar mensagem. Tente novamente.' + error,
                        );
                      }
                    } catch (error) {
                      console.error('Erro ao enviar mensagem:', error);
                      alert(
                        'Erro ao enviar mensagem. Tente novamente.' + error,
                      );
                    }
                  }}
                >
                  Enviar
                </Button>
              </Box>
            </>
          )}

          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => setShowLinkModal(false)}>Fechar</Button>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default GDFSearch;
